<div class="payment-methods-card-body-item" *ngFor="let paymentMethod of paymentMethods">
  <app-payment-methods-item
    [paymentMethod]="paymentMethod"
    [formGroup]="formGroup"
    [isShowFee]="isShowFee"
    [isSkipHints]="isSkipHints"
  ></app-payment-methods-item>
</div>
